module.exports = __webpack_public_path__ + "static/media/banner_lulc_data.9e671eee.jpg";